import React from "react";

const DateInput = ({
  defaultValue,
  onChange,
  value,
  className,
  min,
  readOnly,
}) => {
  return (
    <div>
      <input
        type="date"
        className={`w-full lg:text-xxs sm:px-px sm:mx-mx md:text-xxs md:px-0.5 px-3 py-1 border rounded outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500 border-gray-200 ${className}`}
        defaultValue={defaultValue}
        value={value ? value : ""}
        onChange={onChange}
        min={min}
        readOnly={readOnly}
      />
    </div>
  );
};

export default DateInput;
